<template>
	<section class="content-wrapper ce-html">
		<div v-html="objectdata.html"/>
	</section>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		created() {
			let objThis = this;
			window.addEventListener("scroll", e => {
				let animatedImageBoxes = document.querySelectorAll(
					".bottle-image img.animated"
				);

				let animatedTextBoxes = document.querySelectorAll(
					".bottle-text.animated"
				);

				[].forEach.call(animatedImageBoxes, el => {
					if (objThis.inViewport(el)) {
						el.classList.add("fadeInLeft");
					}
				});
				[].forEach.call(animatedTextBoxes, el => {
					if (objThis.inViewport(el)) {
						el.classList.add("fadeInRight");
					}
				});
			});
		},
		methods: {},
		composed: {}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";

	// sugar boxes
	.sugar-boxes {
		margin: 20px 0;

		.sugar-box {
			display: block;
			margin-bottom: 20px;

			@include min-screen($screen-min-content) {
				display: flex;
				align-items: top;
				margin-bottom: 0;
			}

			.bottle-image,
			.bottle-text {
				@include min-screen($screen-min-content) {
					flex: 1;
					justify-content: top;
				}
			}

			.bottle-image {
				@include min-screen($screen-min-content) {
					border-right: 1px solid $color-green;
				}

				img {
					height: auto;
					opacity: 0;
					max-width: 220px;

					@include min-screen($screen-min-content) {
						margin-bottom: 60px;
					}
				}
			}

			.bottle-text {
				opacity: 0;
				padding: 15px 15px 15px 0;
				@include min-screen($screen-min-content) {
					padding: 15px 15px 15px 20px;
				}
				p {
					&:first-of-type {
						margin-bottom: 0;
					}
				}

				strong {
					color: $color-green;
				}
			}
		}
	}
</style>